<template lang="pug">
  SspLayout.expansions(area="core")
    template(slot="actions")
      router-link.btn.btn-primary(:to="{name: 'topUp', params: { id: orderId }}")
        i.fa.fa-plus
        span.ml5 Top-up
      button.btn.btn-default(@click="$refs.checkCodeModal.open()" v-visible-for="['ROLE_CODE_DOWNLOADER']")
        i.fa.fa-eye
        span.ml5 Check Code
    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Code Type
        th Code Length
        th Start-End Index
        th Size
        th Created
        th Created By
        th Name
        th Status
        th Bundle
        th
      tr(v-for="(e, index) in expansions")
        td
          span(v-if="e.codeConfiguration") {{e.codeConfiguration.type}} - {{e.codeConfiguration.name}}
        td {{e.codeLength}}
        td
          span(v-if="e.first && e.last") {{e.first.codeIndex}} - {{e.last.codeIndex}}
        td {{e.size | number}}
        td {{e.created | date}}
        td(v-if="e.createdBy")  {{e.createdBy.username}}
        td {{e.name}}
        td
          i.label.label-primary.expansion-label(v-if="e.codeType") {{e.codeType}}
          i.label.label-primary.expansion-label(v-if="e.status === 'LOCKED_FOR_PRINTING'") LOCKED
          i.label.label-primary.expansion-label(v-if="e.status === 'PRINTED'") PRINTED
        td
          span(v-if="e.bundle") {{e.bundle.id}}
          em.text-muted(v-else) not bundled
        td.actions
          a.btn-download(:href="`/ssp/serialization/v1/codes/expansions/${e.id}.zip`" v-visible-for="['ROLE_CODE_DOWNLOADER']")

    CheckCodeModal(ref="checkCodeModal" :orderId="orderId" @error="$emit('error', $event)")
</template>

<script>
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'
import { numberFilter, dateFilter, expansionType } from '@/filters/filters'
import CheckCodeModal from './CheckCodeModal'

export default {
  data: () => ({
    expansions: null
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      return Core.listOrderExpansions(this.orderId, req)
        .then((resp) => {
          this.expansions = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  computed: {
    orderId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    DataGrid,
    CheckCodeModal
  },
  filters: {
    number: numberFilter,
    date: dateFilter,
    type: expansionType
  }
}
</script>

<style lang="scss">
.expansions {
  .expansion-label {
    display: block;
    margin-top: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/code/Expansions.vue